import { Box, Typography } from "@mui/material";
import styles from "./styles";
import { useTranslation } from "react-i18next";
import Header from "../../containers/Header";

const UnderConstruction = () => {
    const { t } = useTranslation();
    return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Header
          name={t("settings")} setErrorToast={function (value: boolean): void {
            throw new Error("Function not implemented.");
          } } setErrorToastMsg={function (value: string): void {
            throw new Error("Function not implemented.");
          } } setSuccessToast={function (value: boolean): void {
            throw new Error("Function not implemented.");
          } } setSuccessToastMsg={function (value: string): void {
            throw new Error("Function not implemented.");
          } }       
      />
     <Typography sx={styles.container}>{t("comingSoon")}</Typography>;
    </Box>
  );
};

export default UnderConstruction;
